export default [
  {
    title: 'd2admin 经典',
    name: 'd2',
    preview: 'image/theme/d2/preview@2x.png'
  },
  {
    title: '紫罗兰',
    name: 'violet',
    preview: 'image/theme/violet/preview@2x.png'
  },
  {
    title: '简约线条',
    name: 'line',
    backgroundImage: 'image/theme/line/bg.jpg',
    preview: 'image/theme/line/preview@2x.png'
  },
  {
    title: '流星',
    name: 'star',
    backgroundImage: 'image/theme/star/bg.jpg',
    preview: 'image/theme/star/preview@2x.png'
  },
  {
    title: 'Tomorrow Night Blue (vsCode)',
    name: 'tomorrow-night-blue',
    preview: 'image/theme/tomorrow-night-blue/preview@2x.png'
  }
]
